import { render, staticRenderFns } from "./SystemTodoList.vue?vue&type=template&id=71cf3fb6&scoped=true"
import script from "./SystemTodoList.vue?vue&type=script&lang=js"
export * from "./SystemTodoList.vue?vue&type=script&lang=js"
import style0 from "./SystemTodoList.vue?vue&type=style&index=0&id=71cf3fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf3fb6",
  null
  
)

export default component.exports